module.exports = __webpack_public_path__ + "img/logo.3eb7ee60.png";